<app-lfsa-card *ngIf="mostrarFormulario === MOSTRAR_GRID" [innTemplate]="enviarTemplate"
               [titulo]="'Reglas de Operación Bancaria'">
</app-lfsa-card>
<ng-template #enviarTemplate>
  <div class="row">
    <div class="form-group col-md-10 ">
      <input #quickFilter (keyup)="onQuickFilterChanged() " [(ngModel)]="textoBuscar" class="form-control float-left "
             id="quickFilter " placeholder="Buscar.. "/>
    </div>
    <div class="form-group col-md-2">
      <button (click)="agregarReglaOpBanca()" class="btn btn-success btn-block">Agregar</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 ">
      <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
      <div *ngIf="!loading">
        <div *ngIf="listaVacia" class="alert alert-danger animated fadeInRight" role="alert">
          No existen datos para la lista de Plantas.
        </div>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                         [frameworkComponents]="frameworkComponents " [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                         [pagination]="true" [rowData]="rowData" [rowSelection]="rowSelection"
                         class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.id}}">
        </ag-grid-angular>
      </div>
    </div>
  </div>
</ng-template>

<app-lfsa-card *ngIf="mostrarFormulario === MOSTRAR_ADD_PLANTA" [innTemplate]="enviarTemplateForm"
               [titulo]="'Agregar Regla'">
</app-lfsa-card>
<ng-template #enviarTemplateForm>
  <div class="row">

    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <div class="card border-success">
        <div class="card-body">
          <form [formGroup]="formulario" class="form-group" novalidate>
            <div class="row 12">
              <div class="form-group col-md-12">
                <h5><b>Regla:</b> {{ dataUsuarioDestino.username }} </h5>
              </div>
            </div>
            <div class="row 12">
              <div class="form-group col-md-4">
                <app-lfsa-combo-box (change)="cargarBancoEmpresa()" [claseLabel]="'letrasDanger'"
                                    [comboBox]="cmbEmpresa"
                                    [control]="formulario.get('empresa')" [idOpcion]="'idEmpresa'" [id]="'empresa'"
                                    [label]="'Empresa'" [opcion]="'dscaEmpresa'"
                                    formControlName="empresa"></app-lfsa-combo-box>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-combo-box (change)="elegirBanco()" [claseLabel]="'letrasDanger'" [comboBox]="cmbBancos"
                                    [control]="formulario.get('idBanco')" [idOpcion]="'idBanco'" [id]="'idBanco'"
                                    [label]="'Id Banco'" [opcion]="'dscaBanco'"
                                    formControlName="idBanco"></app-lfsa-combo-box>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('refBanco')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('refBanco')" [id]="'refBanco'" [isReadOnly]="'true'"
                                [label]="'Ref. Banco*'"
                                [type]="'string'" formControlName="refBanco">
                </app-lfsa-input>
              </div>
            </div>
            <div class="row 12">
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('codBanco')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('codBanco')" [id]="'codBanco'"
                                [label]="'Codigo Banco*'"
                                [type]="'string'" formControlName="codBanco">
                </app-lfsa-input>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('descripcionConcepto')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('descripcionConcepto')" [id]="'descripcionConcepto'"
                                [label]="'Descripción concepto*'"
                                [type]="'string'"
                                formControlName="descripcionConcepto">
                </app-lfsa-input>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('tcTipoTransaccion')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('tcTipoTransaccion')" [id]="'tcTipoTransaccion'"
                                [label]="'TC Tipo Transacción*'"
                                [type]="'string'"
                                formControlName="tcTipoTransaccion">
                </app-lfsa-input>
              </div>
            </div>
            <div class="row 12">
              <div class="form-group col-md-4">
                <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbSigno"
                                    [control]="formulario.get('signo')"
                                    [idOpcion]="'id'" [id]="'signo'"
                                    [label]="'Signo*'" [opcion]="'descripcion'"
                                    formControlName="signo"></app-lfsa-combo-box>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('operacionInternaSap')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('operacionInternaSap')" [id]="'operacionInternaSap'"
                                [label]="'Operación interna SAP'"
                                [type]="'string'"
                                formControlName="operacionInternaSap">
                </app-lfsa-input>
              </div>
            </div>
            <div class="row 12">
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('tipo')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('tipo')" [id]="'tipo'"
                                [label]="'Tipo*'"
                                [type]="'string'" formControlName="tipo">
                </app-lfsa-input>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('tipoMov')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('tipoMov')" [id]="'tipoMov'"
                                [label]="'Tipo Movimiento*'"
                                [type]="'string'" formControlName="tipoMov">
                </app-lfsa-input>
              </div>
            </div>
            <div class="row 12">
              <div *ngIf="!loadingSeg" class="form-group col-md-6">
                <label>&nbsp;</label>
                <button (click)="acciones('save')" [disabled]="formulario.invalid"
                        class="btn btn-success btn-block"><i aria-hidden="true" class="fa fa-floppy-o"></i>Guardar
                </button>
              </div>
              <div *ngIf="!loadingSeg" class="form-group col-md-6">
                <label>&nbsp;</label>
                <button (click)="acciones('regresar')" class="btn btn-danger btn-block"><i aria-hidden="true"
                                                                                           class="fa fa-arrow-left"></i>
                </button>
              </div>
            </div>
            <div class="row 12">
              <div class="form-group  col-md-12 ">
                <label>&nbsp;</label>
                <div *ngIf="formulario.invalid" class="alert alert-danger" role="alert">El botón se activara
                  cuando
                  complete toda la información.
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<app-lfsa-card *ngIf="mostrarFormulario === MOSTRAR_ENVIAR_PLANTAS" [innTemplate]="enviarTemplateFormPlastas"
               [titulo]="'Editar Regla'">
</app-lfsa-card>
<ng-template #enviarTemplateFormPlastas>
  <div class="row">

    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <div class="card border-success">
        <div class="card-body">
          <form [formGroup]="formulario" class="form-group" novalidate>
            <div class="row 12">
              <div class="form-group col-md-12">
                <h5><b>Modificar Regla:</b> {{ dataUsuarioDestino.username }} </h5>
              </div>
            </div>
            <div class="row 12">
              <div class="form-group col-md-4">
                <app-lfsa-combo-box (change)="cargarBancoEmpresa()" [claseLabel]="'letrasDanger'"
                                    [comboBox]="cmbEmpresa"
                                    [control]="formulario.get('empresa')" [idOpcion]="'idEmpresa'" [id]="'empresa'"
                                    [label]="'Empresa'" [opcion]="'dscaEmpresa'"
                                    formControlName="empresa"></app-lfsa-combo-box>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-combo-box (change)="elegirBanco()" [claseLabel]="'letrasDanger'" [comboBox]="cmbBancos"
                                    [control]="formulario.get('idBanco')" [idOpcion]="'idBanco'" [id]="'idBanco'"
                                    [label]="'Id Banco'" [opcion]="'dscaBanco'"
                                    formControlName="idBanco"></app-lfsa-combo-box>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('refBanco')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('refBanco')" [id]="'refBanco'" [isReadOnly]="'true'"
                                [label]="'Ref. Banco*'"
                                [type]="'string'" formControlName="refBanco">
                </app-lfsa-input>
              </div>
            </div>
            <div class="row 12">
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('codBanco')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('codBanco')" [id]="'codBanco'"
                                [label]="'Codigo Banco*'"
                                [type]="'string'" formControlName="codBanco">
                </app-lfsa-input>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('descripcionConcepto')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('descripcionConcepto')" [id]="'descripcionConcepto'"
                                [label]="'Descripción concepto*'"
                                [type]="'string'"
                                formControlName="descripcionConcepto">
                </app-lfsa-input>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('tcTipoTransaccion')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('tcTipoTransaccion')" [id]="'tcTipoTransaccion'"
                                [label]="'TC Tipo Transacción*'"
                                [type]="'string'"
                                formControlName="tcTipoTransaccion">
                </app-lfsa-input>
              </div>
            </div>
            <div class="row 12">
              <div class="form-group col-md-4">
                <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbSigno"
                                    [control]="formulario.get('signo')"
                                    [idOpcion]="'id'" [id]="'signo'"
                                    [label]="'Signo*'" [opcion]="'descripcion'"
                                    formControlName="signo"></app-lfsa-combo-box>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('operacionInternaSap')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('operacionInternaSap')" [id]="'operacionInternaSap'"
                                [label]="'Operación interna SAP'"
                                [type]="'string'"
                                formControlName="operacionInternaSap">
                </app-lfsa-input>
              </div>
            </div>
            <div class="row 12">
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('tipo')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('tipo')" [id]="'tipo'"
                                [label]="'Tipo*'"
                                [type]="'string'" formControlName="tipo">
                </app-lfsa-input>
              </div>
              <div class="form-group col-md-4">
                <app-lfsa-input (input)="this.formulario.get('tipoMov')" [claseLabel]="'letrasDanger'"
                                [control]="this.formulario.get('tipoMov')" [id]="'tipoMov'"
                                [label]="'Tipo Movimiento*'"
                                [type]="'string'" formControlName="tipoMov">
                </app-lfsa-input>
              </div>
            </div>
            <div class="row 12">
              <div *ngIf="!loadingSeg" class="form-group col-md-6">
                <label>&nbsp;</label>
                <button (click)="acciones('editarSeg')" [disabled]="formulario.invalid"
                        class="btn btn-success btn-block"><i aria-hidden="true" class="fa fa-floppy-o">Actualizar</i>
                </button>
              </div>
              <div *ngIf="!loadingSeg" class="form-group col-md-6">
                <label>&nbsp;</label>
                <button (click)="acciones('regresar')" class="btn btn-danger btn-block"><i aria-hidden="true"
                                                                                           class="fa fa-arrow-left"></i>
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>

  </div>
</ng-template>
